export default __webpack_public_path__ + "static/media/lotusweapon.6b1b4a72.png";